import {html, LitElement} from "lit";

import {Router} from "@vaadin/router";
import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {HeaderNav} from "./HeaderNav.js";
import {TopProgressBar} from "./TopProgressBar.js";

/**
 * @customElement
 */
export class MainLayout extends ResolvingLitElement {

    static properties = {
        __hasPendingChildren: {},
        __pendingCount: {}
    };

    constructor() {
        super();

        this.__hasPendingChildren = false;
        this.__pendingCount = 0;

        this.addEventListener('pending-state', async e => {
            this.__hasPendingChildren = true;
            this.__pendingCount++;
            try {
                await e.detail.promise;
            } finally {
                this.__pendingCount--;
                this.__hasPendingChildren = this.__pendingCount !== 0;
            }

        });
    }

    render() {
        return html`
            <x-top-progress-bar></x-top-progress-bar>
            <div class="container">
                <x-header-nav currenttheme="auto"></x-header-nav>
            </div>
            <slot></slot>`
    }

    createRenderRoot() {
        return this;
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('__pendingCount')) {
            let bar = this.renderRoot.querySelector('x-top-progress-bar');
            if (!this.__pendingCount) {
                bar.percent = 100;
                return;
            }
            if (this.__pendingCount === 1) {
                bar.percent = 50;
                return;
            }
            bar.percent = 100/this.__pendingCount;
        }
    }
}

customElements.define('x-main-layout', MainLayout);